"use client";

import { RefObject, useEffect } from "react";

export default function ViewportProvider({ children, elementRef }: { children: React.ReactNode, elementRef?: React.RefObject<HTMLElement> | null }) {
    // useEffect(() => {
    //     if (window) setViewportHeight(window.visualViewport.height);
    //     function handleOnViewportChange(e: Event) {
    //         // console.log("change")
    //         const { height } = window?.visualViewport;
    //         setViewportHeight(height);
    //     }
    //     window?.visualViewport.addEventListener("resize", handleOnViewportChange);
    //     return () => window?.visualViewport.removeEventListener("resize", handleOnViewportChange);
    // }, [])


    useEffect(() => {
        const setVh = () => {
            const visualHeight = window.visualViewport?.height ?? window.innerHeight;
            const target = elementRef?.current || document.documentElement;
            target.style.setProperty("--vh", `${visualHeight * 0.01}px`);
        };
        setVh();
        visualViewport.addEventListener("resize", setVh);
        window.addEventListener("orientationchange", setVh);
        return () => {
            visualViewport.removeEventListener("resize", setVh);
            window.removeEventListener("orientationchange", setVh);
        };
    }, []);

    return <>{children}</>;
}
